import { SelectWithAll } from "../components/SelectWithAll";
import { SourcePicker } from "../components/SourcePicker";
import { useNotifications } from "../features/notifications";
import { arrayToDistinct } from "../helper/arrayToDistinct";
import { arrayToTree, treeToArray } from "../helper/arrayToTree";
import { catchError } from "../helper/catchError";
import * as ColorConvert from "../helper/ColorConvert";
import { equals } from "../helper/equals";
import { isType } from "../helper/isType";
import { useAppState } from "../hooks/useAppState";
import { useBreadcrumb } from "../hooks/useBreadcrumb";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { useFeedback } from "../hooks/useFeedback";
import { useHref } from "../hooks/useHref";
import { useNavigation } from "../hooks/useNavigation";
import { useOpenDashApp } from "../hooks/useOpenDashApp";
import { useOpenDashServices } from "../hooks/useOpenDashServices";
import { usePath } from "../hooks/usePath";
import { usePermission } from "../hooks/usePermission";
import { usePermissions } from "../hooks/usePermissions";
import { useSource } from "../hooks/useSource";
import { useStorage } from "../hooks/useStorage";
import { useStorageService } from "../hooks/useStorageService";
import { useUrlParam } from "../hooks/useUrlParam";
import { useUserService } from "../hooks/useUserService";
import { useDebounce } from "../react-helper/useDebounce";
import { useDeepCompareCallback } from "../react-helper/useDeepCompareCallback";
import { useDeepCompareEffect } from "../react-helper/useDeepCompareEffect";
import { useDeepCompareMemo } from "../react-helper/useDeepCompareMemo";
import { useDeepCompareMemoize } from "../react-helper/useDeepCompareMemoize";
import { useElementSize } from "../react-helper/useElementSize";
import { useEventListener } from "../react-helper/useEventListener";
import { useForceRender } from "../react-helper/useForceRender";
import { useImmerState } from "../react-helper/useImmerState";
import { useInterval } from "../react-helper/useInterval";
import { useLocalStorage } from "../react-helper/useLocalStorage";
import { useObjectState } from "../react-helper/useObjectState";
import { usePromise } from "../react-helper/usePromise";
import { useServiceStore } from "../react-helper/useServiceStore";
import { useStore } from "../react-helper/useStore";
export class Core {
}
Core.React = {
    Components: {
        Inputs: {
            SelectWithAll,
            SourcePicker,
        },
    },
    Hooks: {
        useFeedback,
        useAppState,
        useCurrentUser,
        useBreadcrumb,
        useHref,
        useNavigation,
        useOpenDashApp,
        useOpenDashServices,
        usePath,
        usePermission,
        usePermissions,
        useSource,
        useStorage,
        useStorageService,
        useUrlParam,
        useUserService,
        useDebounce,
        useDeepCompareCallback,
        useDeepCompareEffect,
        useDeepCompareMemo,
        useDeepCompareMemoize,
        useElementSize,
        useEventListener,
        useForceRender,
        useImmerState,
        useInterval,
        useLocalStorage,
        useObjectState,
        usePromise,
        useServiceStore,
        useStore,
        useNotifications,
    },
};
Core.Helpers = {
    General: {
        isType,
        equals,
        catchError,
    },
    Array: {
        toDistinct: arrayToDistinct,
        toTree: arrayToTree,
        fromTree: treeToArray,
    },
    Colors: ColorConvert,
};
//# sourceMappingURL=Core.js.map